import { ArrowRight, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import FormationDialog from "./FormationDialog";
import Photo from "./Photo";
import Reveal from "./Reveal";
import useI18n from "@/i18n";

export default function Medecin() {
    const { t, to } = useI18n();

    return (
        <section id="medecin" className="grad-rose-down scroll-mt-24 py-16 md:py-24" data-testid="medecin-section">
            <div className="mx-auto grid max-w-[1080px] items-center gap-10 px-5 md:grid-cols-[320px_1fr] md:gap-14">
                <Reveal>
                    <Photo
                        file="medecin.jpg"
                        alt={t.medecinSection.photoAlt}
                        position="50% 20%"
                        ratioClass="arch aspect-[4/5]"
                        frameStyle={{ border: "2px solid var(--c-gold)", borderBottom: "none" }}
                        className="mx-auto w-full max-w-[240px] md:mx-0 md:max-w-[320px]"
                    />
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="eyebrow">{t.medecinSection.eyebrow}</p>
                    <h2 className="mt-3 text-3xl text-terrat md:text-4xl">{t.medecinSection.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-5 max-w-[56ch]">{t.medecinSection.lead}</p>
                    <ul className="mt-6 flex flex-wrap gap-2.5" data-testid="medecin-tags">
                        {t.formation.expertises.map((item) => (
                            <li
                                key={item}
                                className="rounded-full bg-white/70 px-4 py-1.5 text-sm text-ink"
                                style={{ border: "1px solid rgba(201,162,75,0.45)" }}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-7 flex flex-wrap items-center gap-4">
                        <FormationDialog
                            trigger={
                                <button type="button" className="btn btn-primary" data-testid="formation-button">
                                    <GraduationCap size={17} aria-hidden="true" />
                                    {t.medecinSection.formationButton}
                                </button>
                            }
                        />
                        <p className="text-sm text-ink2" data-testid="rpps-medecin">
                            {t.medecinSection.rpps}
                        </p>
                    </div>
                    <Link
                        to={to("medecin")}
                        className="link-underline mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-terrat"
                        data-testid="medecin-detail-link"
                    >
                        {t.medecinSection.detailLink}
                        <ArrowRight size={14} aria-hidden="true" />
                    </Link>
                </Reveal>
            </div>
        </section>
    );
}
